import {MENU_NAVIGATION} from '@eta/components';
import { ReduxStateSampleState, ReduxStateSampleActions, CHANGE_MYCONTENT } from './Types';



const initialState: ReduxStateSampleState = {
    mycontent: ''
};

export function reduxStateSampleReducer(state = initialState, action: ReduxStateSampleActions) {
    switch (action.type) {

        case MENU_NAVIGATION:
            if (action.payload.id === 'SampleReduxState'){
            return {
                ...state,
                mycontent: ''
            };
        }
        return {...state};
        case CHANGE_MYCONTENT:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}
